import { Icon } from "@iconify/react";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { BottomSheet } from "react-spring-bottom-sheet";
import { BreadcrumbContext } from "../../common/BreadcrumbContext";
import { MobileCardList } from "../../common/CardList";
import { t } from "../../common/ErrorMessage";
import { IS_MOBILE } from "../../common/Responsive";
import { iconUrl } from "../../config";
import { tableCol } from "../../utils";
import { getData, getErr, safeErrCode } from "../../utils/api-request";
import { listTable } from "../../utils/helper";
import history from "../../utils/history";
import { mobileSearchInput, searchInput } from "../booking/bookingHelper";
import { MobileEmptyData } from "../Empty/EmptyData";

const RoomList = () => {
  const {
    setpathLocation,
    openButtonSheet,
    setOpenButtonSheet,
    setShowFilter,
  } = useContext(BreadcrumbContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [roomList, setRoomList] = useState([]);
  const tableHeader = ["Room Number", "Room Type", "Bed Type", "Floor"];

  const getRoomList = useCallback((search = "") => {
    setLoading(true);
    getData(`/api/v1/master/room?roomnumber=${search}`)
      .then((resp) => {
        setLoading(false);
        if (resp.data) {
          setRoomList(resp?.data);
        } else {
          resp.json().then((err) => {
            setError(t(safeErrCode(err)));
          });
        }
      })
      .catch((error) => {
        let err = getErr(error);
        setLoading(false);
        setError(t(err));
      });
  }, []);

  const handleChange = (val) => {
    setSearch(val.target.value);
  };

  useEffect(() => {
    if (search === "") {
      getRoomList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, getRoomList]);

  useEffect(() => {
    setpathLocation(history.location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const trTable = (item, i) => {
    return (
      <tbody className="f8-vw" key={i}>
        <tr className={tableCol(i)}>
          <td className="text-center align-middle">{item.room_number}</td>
          <td className="align-middle">{item.room_type_name}</td>
          <td className="text-center align-middle">{item.bed_type_name}</td>
          <td className="text-center align-middle">{item.floor}</td>
        </tr>
      </tbody>
    );
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      getRoomList(search);
    }
  };

  const resetFilter = () => {
    setSearch("");
  };

  useEffect(() => {
    setShowFilter(true);
    return () => {
      setShowFilter(false);
    };
  }, [setShowFilter]);

  return (
    <>
      {IS_MOBILE ? (
        <div className="d-flex flex-column px-3 py-1 mb-5">
          <div className="col px-1">
            {roomList?.length > 0 ? (
              roomList.map((item, i) => {
                return (
                  <MobileCardList title={`Kamar ${item?.room_number}`} key={i}>
                    <div className="card-hms-list">
                      <div className="col-4 px-0 grey-text">Lantai</div>
                      <div className="col pr-0 f12-vw black-value">
                        {item.floor}
                      </div>
                    </div>
                    <div className="card-hms-list">
                      <div className="col-4 px-0 grey-text">Room Type</div>
                      <div className="col pr-0 f12-vw black-value">
                        {item.room_type_name}
                      </div>
                    </div>
                    <div className="card-hms-list">
                      <div className="col-4 px-0 grey-text">Bed Type</div>
                      <div className="col pr-0 f12-vw black-value">
                        {item.bed_type_name}
                      </div>
                    </div>
                  </MobileCardList>
                );
              })
            ) : (
              <div style={{ position: "relative" }}>
                <MobileEmptyData
                  errMessage={error}
                  loading={loading}
                  height="40vh"
                  sourceImg={"/img/master-data/room-allocation.svg"}
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="d-flex flex-column px-4 py-1">
          <div className="col px-2">
            <div className="d-flex flex-row justify-content-between">
              <div className="col-md-9 px-0">
                <div className="d-flex flex-row">
                  <div className="col-3 px-0 mr-2">
                    <label htmlFor="" className="f8-vw m-0 p-0">
                      Nomor Kamar
                    </label>
                    {searchInput(
                      "Cari Nomor Kamar",
                      search,
                      (e) => handleChange(e),
                      (e) => handleEnter(e)
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-2 pr-0 pl-5 mt-auto">
                <div className="d-flex flex-column">
                  <button
                    className="btn btn-sm search-new rounded-input btn-block mt-auto f8-vw fw-500 text-white"
                    onClick={() => {
                      getRoomList(search);
                    }}
                    style={{
                      paddingTop: 7,
                      paddingBottom: 7,
                      backgroundColor: "#742B9E",
                    }}
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col px-2 mt-0">
            <div className="my-3">
              {listTable(
                tableHeader,
                roomList,
                trTable,
                loading,
                error,
                "/img/master-data/room-allocation.svg"
              )}
            </div>
          </div>
        </div>
      )}

      {IS_MOBILE && (
        <div>
          <BottomSheet
            open={openButtonSheet}
            onDismiss={() => setOpenButtonSheet(false)}
            snapPoints={({ minHeight }) => minHeight}
            header={
              <div className="d-flex justify-content-between">
                <span className="purple f16-vw fw-600 px-2">Filter</span>
                <span
                  className="px-2"
                  onClick={() => setOpenButtonSheet(false)}
                >
                  <Icon icon={iconUrl.closeBold} color={"grey"} width={20} />
                </span>
              </div>
            }
            footer={
              <div className="d-flex justify-content-between">
                <div className="col-6 pl-2">
                  <button
                    className="btn btn-block btn-outline-purple f12-vw"
                    onClick={() => {
                      resetFilter();
                      setOpenButtonSheet(false);
                      setRoomList([]);
                      getRoomList();
                    }}
                  >
                    Reset
                  </button>
                </div>
                <div className="col-6 pr-2">
                  <button
                    className="btn btn-block btn-gradient f12-vw text-white"
                    onClick={() => {
                      setOpenButtonSheet(false);
                      getRoomList(search);
                    }}
                  >
                    Search
                  </button>
                </div>
              </div>
            }
          >
            <div className="mt-3" style={{ height: "10rem" }}>
              <div className="px-4 mt-2">
                <label htmlFor="" className="f12-vw m-0 p-0 fw-600">
                  Nomor Kamar
                </label>
                {mobileSearchInput("Cari Nomor Kamar", search, (e) =>
                  handleChange(e)
                )}
              </div>
            </div>
          </BottomSheet>
        </div>
      )}
    </>
  );
};

export default RoomList;
